/* src/app/FW/controls/timepicker-entry/w-time-dialog/w-time-dialog.component.scss */
.w-timepicker-dialog {
  padding: 0;
  margin: -24px;
  width: calc(100% + 48px);
}
/*# sourceMappingURL=w-time-dialog.component.css.map */
